import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useApp } from "@/context/AppProvider";

export const LoadingScreen = ({ onDone }) => {
  const { tr } = useApp();
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      setTimeout(() => onDone && onDone(), 700);
    }, 2100);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="loading-screen"
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ backgroundColor: "var(--bone)" }}
          initial={{ opacity: 1 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="text-center px-6">
            <div className="line-mask">
              <motion.p
                className="eyebrow mb-6 block"
                initial={{ y: "120%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              >
                Portfolio
              </motion.p>
            </div>
            <div className="line-mask">
              <motion.h1
                className="font-display text-4xl md:text-6xl"
                style={{ color: "var(--ink)" }}
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
              >
                {tr.loading}
              </motion.h1>
            </div>
            <motion.div
              className="mt-10 h-[2px] mx-auto overflow-hidden"
              style={{ backgroundColor: "rgba(19,19,19,0.1)", width: 220 }}
            >
              <motion.div
                className="h-full"
                style={{ backgroundColor: "var(--gold)" }}
                initial={{ width: "0%" }}
                animate={{ width: "100%" }}
                transition={{ duration: 1.9, ease: "easeInOut" }}
              />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
